/* VitaGreen Willkommens-Rundgang (Claude, 15.10.2026). Konzept Fassung 2, Go Heinrich 15.10.2026.
   Kein Framework, keine App. Merker im Browser (localStorage "vg_rundgang"), erst nach einer Wahl
   des Besuchers geschrieben. Sitzungsmerker (sessionStorage) verhindert zwei Auftritte je Sitzung.
   Regeln F8: Fertig oder "Nein, danke" = nie wieder. Wegklicken vor 2 gesehenen Schritten = beim
   nächsten Besuch noch einmal klein; zweites Wegklicken = keine automatische Frage mehr.
   Ab 2 gesehenen Schritten erledigt. Höchstens 2 automatische Auftritte.
   Regeln F9: Nach dem Wegklicken bleibt der Reiter "Kurzer Rundgang" unten rechts, bis Fertig
   oder "Nein, danke". Test: ?rundgang=an (Sitzung), ?rundgang=reset (Merker löschen). */
(function () {
  'use strict';
  var cfgEl = document.getElementById('vg-rg-cfg');
  if (!cfgEl) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  var KEY = 'vg_rundgang', SKEY = 'vg_rundgang_sitzung', VKEY = 'vg_rundgang_vorschau';
  function speicher(art) { try { var s = window[art]; var t = '__vg'; s.setItem(t, t); s.removeItem(t); return s; } catch (e) { return null; } }
  var LS = speicher('localStorage'), SS = speicher('sessionStorage');
  function neu() { return { v: 1, s: 'offen', a: 0, g: 0, x: false, r: false }; }
  function lese() { if (!LS) return null; try { var o = JSON.parse(LS.getItem(KEY)); return o && o.v === 1 ? o : null; } catch (e) { return null; } }
  var st = lese() || neu();
  function sichere() { if (LS) { try { LS.setItem(KEY, JSON.stringify(st)); } catch (e) {} } }

  var param = null;
  try { param = new URLSearchParams(window.location.search).get('rundgang'); } catch (e) {}
  if (param === 'reset') {
    if (LS) { try { LS.removeItem(KEY); } catch (e) {} }
    if (SS) { try { SS.removeItem(SKEY); } catch (e) {} }
    st = neu();
  }
  if ((param === 'an' || param === 'reset') && SS) { try { SS.setItem(VKEY, '1'); } catch (e) {} }
  var vorschau = !!(SS && SS.getItem(VKEY) === '1');
  if (param === 'aus' && SS) { try { SS.removeItem(VKEY); } catch (e) {} vorschau = false; }
  var aktiv = CFG.aktiv === true || vorschau;

  function veroeffentliche(aktion, extra) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var d = { aktion: aktion }; if (extra) for (var k in extra) d[k] = extra[k];
        window.Shopify.analytics.publish('vg_rundgang', d);
      }
    } catch (e) {}
  }

  /* ---------- CSS erst bei Bedarf laden (kein Einfluss auf den Seitenaufbau) ---------- */
  var cssBereit = false, cssWarte = [];
  function mitCss(cb) {
    if (cssBereit) { cb(); return; }
    cssWarte.push(cb);
    if (cssWarte.length > 1) return;
    var l = document.createElement('link');
    l.rel = 'stylesheet'; l.href = CFG.css;
    var fertigCss = function () { if (cssBereit) return; cssBereit = true; var w = cssWarte; cssWarte = []; w.forEach(function (f) { try { f(); } catch (e) {} }); };
    l.onload = fertigCss; l.onerror = fertigCss;
    window.setTimeout(fertigCss, 3000);
    document.head.appendChild(l);
  }

  /* ---------- Startknopf auf "Hier starten" ---------- */
  function knoepfeVerbinden() {
    var ks = document.querySelectorAll('[data-vg-rundgang-knopf]');
    for (var i = 0; i < ks.length; i++) if (aktiv) ks[i].hidden = false;
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-vg-rundgang-start]');
      if (!b || !aktiv) return;
      e.preventDefault();
      veroeffentliche('start_knopf');
      mitCss(function () { starte(1, b); });
    });
  }

  /* ---------- Hilfen ---------- */
  var mql = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function sichtbar(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    if (r.bottom <= 0 || r.top >= window.innerHeight || r.right <= 0 || r.left >= window.innerWidth) return false;
    var cs = window.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none' && parseFloat(cs.opacity || '1') > 0.05;
  }
  function menueLink(text) {
    var ls = document.querySelectorAll('header .menu-list__link');
    for (var i = 0; i < ls.length; i++) if ((ls[i].textContent || '').trim() === text && sichtbar(ls[i])) return ls[i];
    return null;
  }
  function burger() { var b = document.querySelector('header summary.header__icon--menu'); return sichtbar(b) ? b : null; }
  function korb() {
    var c = document.querySelector('header [aria-label="Warenkorb"]') || document.querySelector('header .header-actions__cart-icon, header cart-icon');
    if (c && c.closest('button')) c = c.closest('button');
    return sichtbar(c) ? c : null;
  }
  function leiste() { var a = document.querySelector('.announcement-bar'); return sichtbar(a) ? a : null; }
  function kaufbox() {
    if (CFG.seite !== 'product') return null;
    var q = document.querySelector('.vgp-qty');
    if (!q) return null;
    var v = document.querySelector('main variant-picker');
    return v && v.offsetParent ? [v, q] : q;
  }
  function andereOffen() {
    var d = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < d.length; i++) if (!d[i].classList.contains('vg-rg-dlg')) return true;
    if (document.querySelector('header details[open] > summary.header__icon--menu')) return true;
    return false;
  }
  function bannerOffen() {
    var b = document.getElementById('shopify-pc__banner');
    if (b && sichtbar(b)) return true;
    var cp = window.Shopify && window.Shopify.customerPrivacy;
    try {
      if (cp && typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner() && typeof cp.currentVisitorConsent === 'function') {
        var c = cp.currentVisitorConsent() || {};
        if ((c.analytics || '') === '' && (c.marketing || '') === '' && (c.preferences || '') === '') return true;
      }
    } catch (e) {}
    return false;
  }
  function ladeEinwilligungsApi() {
    try {
      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function' && !window.Shopify.customerPrivacy) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
    } catch (e) {}
  }
  function istMobil() { return window.innerWidth < 750; }
  var SCHUTZ = 'main .vgp-qty, main variant-picker, main .vg-vb, main product-form-component, main .product-form, main [class*="buy-buttons"], main .vgp-garantie, main product-price, main .vgp-sticky, .vgp-sticky';
  function ueberlapptSchutz(r) {
    if (CFG.seite !== 'product') return false;
    var s = document.querySelectorAll(SCHUTZ);
    for (var i = 0; i < s.length; i++) {
      if (s[i].closest('.vg-rg-dlg')) continue;
      var q = s[i].getBoundingClientRect();
      if (q.width < 2 || q.height < 2) continue;
      if (q.left < r.right + 8 && q.right > r.left - 8 && q.top < r.bottom + 8 && q.bottom > r.top - 8) return true;
    }
    return false;
  }
  function heuteOk() {
    if (!CFG.chlorella) return false;
    var n = new Date();
    var h = n.getFullYear() + '-' + ('0' + (n.getMonth() + 1)).slice(-2) + '-' + ('0' + n.getDate()).slice(-2);
    var ende = String(CFG.chlorellaEnde || '').trim();
    var m = ende.match(/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/);
    if (m) ende = m[3] + '-' + ('0' + m[2]).slice(-2) + '-' + ('0' + m[1]).slice(-2);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ende)) return true;
    return h <= ende;
  }
  function el(tag, attrs, html) {
    var e = document.createElement(tag);
    if (attrs) for (var k in attrs) { if (k === 'class') e.className = attrs[k]; else e.setAttribute(k, attrs[k]); }
    if (html != null) e.innerHTML = html;
    return e;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Schritte ---------- */
  function schritte() {
    var L = [];
    if (heuteOk()) {
      var bilder = (CFG.chlorellaBilder || '').split(';').filter(Boolean).map(function (x) { var p = x.split('|'); return { src: p[0], alt: p[1] || '' }; });
      L.push({
        id: 'chlorella', klein: 'Jetzt neu', eyebrow: 'Chlorella ist wieder da',
        titel: 'Chlorella ist wieder da',
        text: 'C.P. Protect und C.V. Protect sind wieder lieferbar. Keine Wartezeit mehr: Wir verschicken deine Bestellung am nächsten Werktag.',
        kasten: '10 % Rabatt bis einschließlich 25.10.',
        packungen: bilder, ziele: function () { return []; }
      });
    }
    L.push({
      id: 'menue', eyebrow: 'Dein Weg durch den Shop', titel: 'Oben im Menü findest du alles',
      text: 'Unter „Nach Wirkbereich“ suchst du nach Themen wie Immunsystem oder Energie & Nerven. Unter „Produktwelten“ findest du Chlorella, Omega-3, Vitamine & Mineralien, MSM, Bundles und Bücher.',
      textMobil: 'Tippe oben links auf die drei Striche. Dann öffnet sich das Menü mit „Nach Wirkbereich“ und den „Produktwelten“: Chlorella, Omega-3, Vitamine & Mineralien, MSM, Bundles und Bücher.',
      bild: CFG.bildNavigation, bildMobil: CFG.bildNavigationHandy, bildAlt: 'So sieht das geöffnete Menü aus',
      ziele: function () { var a = menueLink('Nach Wirkbereich'), b = menueLink('Produktwelten'); if (a && b) return [[a, b]]; var m = burger(); return m ? [m] : []; }
    });
    L.push({
      id: 'start', eyebrow: 'Neu bei VitaGreen?', titel: '„Hier starten“ und „Wissen“',
      text: 'Unter „Hier starten“ zeigen wir dir in Ruhe, wie VitaGreen denkt und welche Wege es in den Shop gibt. Unter „Wissen“ liest du Hintergründe zu unseren Rohstoffen, und bei den Produktwelten findest du die Bücher von Dr. Frank Liebke.',
      ziele: function () { var a = menueLink('Hier starten'), b = menueLink('Wissen'); var z = []; if (a) z.push(a); if (b) z.push(b); if (z.length) return z; var m = burger(); return m ? [m] : []; }
    });
    L.push({
      id: 'kaufbox', eyebrow: 'Auf jeder Produktseite', titel: 'Größe und Menge wählen',
      text: 'In der Kaufbox wählst du zuerst die Größe, dann die Menge. Nimmst du mehrere Packungen eines Produkts, wird jede Packung günstiger. Den Vorteil siehst du direkt in der Kaufbox und im Warenkorb.',
      bild: CFG.bildKaufbox, bildAlt: 'Kaufbox mit Größenwahl und Mengenwahl', kaufbox: true,
      ziele: function () { var k = kaufbox(); if (!k) return []; var a = Array.isArray(k) ? k : [k]; return a.some(sichtbar) ? [a] : []; }
    });
    L.push({
      id: 'warenkorb', eyebrow: 'Bequem bestellen', titel: 'Dein Warenkorb und der Versand',
      text: 'Über die Tasche oben rechts öffnest du jederzeit deinen Warenkorb. Versandkostenfrei liefern wir in Deutschland ab 50 €, nach Österreich ab 120 € und in die Schweiz ab 200 €. Die Leiste ganz oben erinnert dich daran.',
      ziele: function () { var z = []; var k = korb(); if (k) z.push(k); var l = leiste(); if (l) z.push(l); return z; }
    });
    L.push({
      id: 'hilfe', eyebrow: 'Wir sind für dich da', titel: 'Fragen? Unter „Hilfe“',
      text: 'Dort findest du Antworten auf häufige Fragen, alles zu Versand & Zahlung und unseren Kontakt. Per Telefon und E-Mail erreichst du uns persönlich.',
      nachsatz: 'Den Rundgang kannst du jederzeit wieder starten, auf der Seite „Hier starten“.',
      ziele: function () { var h = menueLink('Hilfe'); if (h) return [h]; var m = burger(); return m ? [m] : []; }
    });
    return L;
  }

  /* ---------- Abdunklung mit Aussparungen ---------- */
  var schleier = null, aktZiele = [], rafId = 0;
  function rechteck(z) {
    var list = Array.isArray(z) ? z : [z], l = 1e9, t = 1e9, r = -1e9, b = -1e9;
    list.forEach(function (e) { var q = e.getBoundingClientRect(); l = Math.min(l, q.left); t = Math.min(t, q.top); r = Math.max(r, q.right); b = Math.max(b, q.bottom); });
    var p = 6;
    return { x: Math.max(0, l - p), y: Math.max(0, t - p), w: Math.min(window.innerWidth, r + p) - Math.max(0, l - p), h: (b + p) - Math.max(0, t - p) };
  }
  function zeichneSchleier() {
    if (!schleier) return;
    var W = window.innerWidth, H = window.innerHeight;
    var rs = aktZiele.map(rechteck);
    var mask = '', rand = '';
    rs.forEach(function (q) {
      mask += '<rect x="' + q.x + '" y="' + q.y + '" width="' + q.w + '" height="' + q.h + '" rx="12" fill="#000"/>';
      rand += '<rect x="' + q.x + '" y="' + q.y + '" width="' + q.w + '" height="' + q.h + '" rx="12" fill="none" stroke="#E1BB4F" stroke-width="3"/>';
    });
    schleier.innerHTML = '<svg width="' + W + '" height="' + H + '" viewBox="0 0 ' + W + ' ' + H + '" aria-hidden="true" focusable="false"><defs><mask id="vg-rg-maske"><rect width="' + W + '" height="' + H + '" fill="#fff"/>' + mask + '</mask></defs><rect width="' + W + '" height="' + H + '" fill="rgba(35,39,31,.72)" mask="url(#vg-rg-maske)"/>' + rand + '</svg>';
    platziereKarte(rs);
  }
  function plane() { if (rafId) return; rafId = requestAnimationFrame(function () { rafId = 0; zeichneSchleier(); }); }

  /* ---------- Fenster ---------- */
  var dlg = null, innen = null, idx = 0, liste = [], vorherFokus = null, beimSchliessen = null;
  function baueFenster() {
    if (dlg) return;
    schleier = el('div', { class: 'vg-rg-schleier', 'aria-hidden': 'true' });
    document.body.appendChild(schleier);
    dlg = el('dialog', { class: 'vg-rg-dlg', 'aria-labelledby': 'vg-rg-titel', 'aria-describedby': 'vg-rg-text' });
    dlg.innerHTML = '<div class="vg-rg-welle" aria-hidden="true"><svg viewBox="0 0 440 34" preserveAspectRatio="none"><path d="M0 22 C110 4 220 34 330 16 S440 10 440 10 V34 H0Z" fill="#fff"/></svg></div>' +
      '<button type="button" class="vg-rg-zu" data-rg="weg" aria-label="Schließen, später ansehen"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button><div class="vg-rg-innen"></div>';
    innen = dlg.querySelector('.vg-rg-innen');
    document.body.appendChild(dlg);
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); wegklick(); });
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = Array.prototype.filter.call(dlg.querySelectorAll('button, a[href], [tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      var erst = f[0], letzt = f[f.length - 1], akt = document.activeElement;
      if (e.shiftKey && (akt === erst || akt === dlg || akt.id === 'vg-rg-titel')) { e.preventDefault(); letzt.focus(); }
      else if (!e.shiftKey && akt === letzt) { e.preventDefault(); erst.focus(); }
    });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { var r = dlg.getBoundingClientRect(); if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) { wegklick(); return; } }
      var b = e.target.closest('[data-rg]'); if (!b) return;
      var a = b.getAttribute('data-rg');
      if (a === 'ja') { veroeffentliche('ja'); zeigeSchritt(1); }
      else if (a === 'weiter') zeigeSchritt(idx + 1);
      else if (a === 'zurueck') zeigeSchritt(Math.max(1, idx - 1));
      else if (a === 'nein') nein();
      else if (a === 'weg') wegklick();
      else if (a === 'fertig') fertig();
      else if (a === 'chlorella') { st.g = Math.max(st.g, idx); st.x = true; st.r = true; sichere(); veroeffentliche('chlorella_klick'); }
    });
    window.addEventListener('resize', plane, { passive: true });
    window.addEventListener('scroll', plane, { passive: true });
  }
  function oeffne() {
    baueFenster();
    vorherFokus = document.activeElement;
    schleier.hidden = false;
    if (!dlg.open) { try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); } }
    document.documentElement.classList.add('vg-rg-offen');
    versteckeBlase();
  }
  function schliesse() {
    if (dlg && dlg.open) { try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); } }
    if (schleier) { schleier.hidden = true; schleier.innerHTML = ''; }
    aktZiele = [];
    document.documentElement.classList.remove('vg-rg-offen');
    var f = vorherFokus; vorherFokus = null;
    if (f && f.focus && document.contains(f)) { try { f.focus({ preventScroll: true }); } catch (e) {} }
    if (beimSchliessen) { var c = beimSchliessen; beimSchliessen = null; c(); }
  }
  function platziereKarte(rs) {
    if (!dlg || !dlg.open) return;
    var W = window.innerWidth, H = window.innerHeight;
    if (istMobil()) { dlg.style.left = ''; dlg.style.top = ''; dlg.classList.add('vg-rg-dlg--blatt'); return; }
    dlg.classList.remove('vg-rg-dlg--blatt');
    var cw = dlg.offsetWidth, ch = dlg.offsetHeight, left, top;
    if (!rs || !rs.length) { left = (W - cw) / 2; top = Math.max(16, (H - ch) / 2); }
    else {
      var u = { l: rs[0].x, t: rs[0].y, r: rs[0].x + rs[0].w, b: rs[0].y + rs[0].h };
      rs.forEach(function (q) { if (q.w < W * 0.8) { u.b = Math.max(u.b, q.y + q.h); } });
      top = u.b + 16;
      if (top + ch > H - 16) top = u.t - 16 - ch;
      if (top < 16) top = Math.max(16, H - ch - 16);
      left = (u.l + cw > W - 16) ? (u.r - cw) : u.l;
      left = Math.min(Math.max(16, left), W - cw - 16);
    }
    dlg.style.left = Math.round(left) + 'px'; dlg.style.top = Math.round(top) + 'px';
  }
  function fokusTitel() { var t = dlg.querySelector('#vg-rg-titel'); if (t) { try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); } } }

  function zeigeFrage() {
    if ((dlg && dlg.open) || blase) return;
    liste = schritte();
    oeffne();
    idx = 0; aktZiele = [];
    var schild = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 3l7 3v6c0 4.5-3 7.5-7 9-4-1.5-7-4.5-7-9V6l7-3z" stroke="currentColor" stroke-width="2"/><path d="M8.5 12l2.5 2.5 4.5-5" stroke="currentColor" stroke-width="2"/></svg>';
    var logo = document.querySelector('header .header-logo img');
    var lsrc = logo ? (logo.currentSrc || logo.src) : '';
    innen.innerHTML = (lsrc ? '<img class="vg-rg-logo" src="' + esc(lsrc) + '" alt="" width="140" height="32">' : '') +
      '<p class="vg-rg-eyebrow">Schön, dass du da bist</p>' +
      '<h2 id="vg-rg-titel" class="vg-rg-titel" tabindex="-1">Willkommen im neuen VitaGreen-Shop</h2>' +
      '<div id="vg-rg-text"><p>Hier kannst du alles ganz einfach entdecken. Möchtest du, dass wir dich kurz herumführen? Es sind nur ein paar kurze Schritte.</p></div>' +
      '<div class="vg-rg-ruhe">' + schild + '<span>Keine Sorge, diese Anzeige siehst du nur am Anfang. Sie soll dir den Einstieg in den Shop leicht machen und dir besonders viel Freude daran schenken.</span></div>' +
      '<div class="vg-rg-knoepfe"><button type="button" class="vg-rg-btn vg-rg-btn--primaer" data-rg="ja">Ja, gern zeigen</button><button type="button" class="vg-rg-btn vg-rg-btn--nein" data-rg="nein">Nein, danke</button></div>';
    zeichneSchleier();
    fokusTitel();
    veroeffentliche('frage');
  }

  function zeigeSchritt(n) {
    if (!liste.length) liste = schritte();
    var N = liste.length;
    if (n > N) { fertig(); return; }
    oeffne();
    idx = n;
    st.g = Math.max(st.g || 0, n);
    var s = liste[n - 1];
    var mob = istMobil();
    if (s.kaufbox) { var k = kaufbox(); if (k) { var k0 = Array.isArray(k) ? k[0] : k; try { var kt = k0.getBoundingClientRect().top + window.pageYOffset - (mob ? 130 : 150); window.scrollTo(0, Math.max(0, kt)); } catch (e) {} } }
    aktZiele = s.ziele();
    var benutztBurger = mob || (aktZiele.length === 1 && aktZiele[0] === burger());
    var text = (benutztBurger && s.textMobil) ? s.textMobil : s.text;
    var h = '<p class="vg-rg-eyebrow">' + (s.klein ? '<span class="vg-rg-neu">' + esc(s.klein) + '</span>' : '') + 'Schritt ' + n + ' von ' + N + ' · ' + esc(s.eyebrow) + '</p>' +
      '<h2 id="vg-rg-titel" class="vg-rg-titel" tabindex="-1">' + esc(s.titel) + '</h2><div id="vg-rg-text"><p>' + esc(text) + '</p></div>';
    if (s.kasten) h += '<p class="vg-rg-kasten">' + esc(s.kasten) + '</p>';
    if (s.packungen && s.packungen.length) {
      h += '<div class="vg-rg-packungen">' + s.packungen.map(function (p) { return '<img src="' + esc(p.src) + '" alt="' + esc(p.alt) + '" width="120" height="120">'; }).join('') + '</div>';
    }
    var zeigeBild = s.bild && (!aktZiele.length || s.id === 'menue');
    if (s.kaufbox && aktZiele.length) zeigeBild = false;
    if (zeigeBild) { var bs = (mob && s.bildMobil) ? s.bildMobil : s.bild; h += '<img class="vg-rg-bild" src="' + esc(bs) + '" alt="' + esc(s.bildAlt || '') + '" loading="lazy">'; }
    if (s.nachsatz) h += '<p class="vg-rg-nachsatz">' + esc(s.nachsatz) + '</p>';
    var punkte = ''; for (var i = 1; i <= N; i++) punkte += '<i class="' + (i === n ? 'an' : '') + '"></i>';
    h += '<div class="vg-rg-fuss"><div class="vg-rg-punkte" aria-hidden="true">' + punkte + '</div><span class="vg-rg-zaehler">' + n + ' / ' + N + '</span></div>';
    if (s.id === 'chlorella') {
      h += '<div class="vg-rg-knoepfe"><a class="vg-rg-btn vg-rg-btn--primaer vg-rg-btn--voll" data-rg="chlorella" href="' + esc(CFG.chlorellaLink || '/collections/chlorella') + '">Chlorella ansehen</a><button type="button" class="vg-rg-btn vg-rg-btn--zweit" data-rg="weiter">Weiter</button><button type="button" class="vg-rg-btn vg-rg-btn--nein" data-rg="nein">Nein, danke</button></div>';
    } else if (n === N) {
      h += '<div class="vg-rg-knoepfe"><button type="button" class="vg-rg-btn vg-rg-btn--primaer vg-rg-btn--voll" data-rg="fertig">Viel Freude beim Entdecken</button>' + (n > 1 ? '<button type="button" class="vg-rg-btn vg-rg-btn--zweit" data-rg="zurueck">Zurück</button>' : '') + '</div>';
    } else {
      h += '<div class="vg-rg-knoepfe"><button type="button" class="vg-rg-btn vg-rg-btn--primaer" data-rg="weiter">Weiter</button>' + (n > 1 ? '<button type="button" class="vg-rg-btn vg-rg-btn--zweit" data-rg="zurueck">Zurück</button>' : '') + '<button type="button" class="vg-rg-btn vg-rg-btn--nein" data-rg="nein">Nein, danke</button></div>';
    }
    innen.innerHTML = h;
    zeichneSchleier();
    fokusTitel();
    veroeffentliche('schritt', { schritt: n, id: s.id });
  }

  function starte(n, ausloeser) {
    if (blase) versteckeBlase();
    liste = schritte();
    zeigeSchritt(Math.min(Math.max(1, n || 1), liste.length));
  }

  /* ---------- Ausgänge ---------- */
  function wegklick() {
    if ((st.g || 0) < 2) { st.a = Math.min(2, (st.a || 0) + (st.x ? 0 : 1)); if (st.a >= 2) st.x = true; }
    else st.x = true;
    st.r = true; sichere();
    veroeffentliche('weggeklickt', { gesehen: st.g });
    beimSchliessen = zeigeReiter;
    schliesse(); versteckeBlase();
  }
  function nein() {
    st.s = 'nein'; st.r = false; sichere();
    veroeffentliche('nein');
    schliesse(); versteckeBlase(); versteckeReiter();
  }
  function fertig() {
    st.s = 'erledigt'; st.r = false; sichere();
    veroeffentliche('fertig');
    schliesse(); versteckeReiter();
  }

  /* ---------- Reiter "Kurzer Rundgang" (Stelle des früheren Chat-Knopfs) ---------- */
  var reiter = null, reiterTimer = 0;
  var kompass = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"/><path d="M15.5 8.5l-2 5-5 2 2-5 5-2z" fill="currentColor"/></svg>';
  function zeigeReiter() {
    if (st.s !== 'offen') return;
    if (!reiter) {
      reiter = el('div', { class: 'vg-rg-reiter', role: 'region', 'aria-label': 'Kurzer Rundgang' });
      reiter.innerHTML = '<button type="button" class="vg-rg-reiter__los">' + kompass + '<span>Kurzer Rundgang</span></button><button type="button" class="vg-rg-reiter__aus" aria-label="Rundgang ausblenden, nein danke"><svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
      reiter.querySelector('.vg-rg-reiter__los').addEventListener('click', function () {
        veroeffentliche('reiter_klick');
        var N = schritte().length, g = st.g || 0;
        starte(g >= 2 && g < N ? g + 1 : 1);
      });
      reiter.querySelector('.vg-rg-reiter__aus').addEventListener('click', nein);
      document.body.appendChild(reiter);
    }
    reiter.hidden = false;
    pruefeReiter();
    if (!reiterTimer) {
      reiterTimer = window.setInterval(pruefeReiter, 400);
      window.addEventListener('scroll', planeReiter, { passive: true });
      window.addEventListener('resize', planeReiter, { passive: true });
      document.addEventListener('transitionrun', planeReiter, true);
      document.addEventListener('animationstart', planeReiter, true);
    }
  }
  var reiterRaf = 0;
  var reiterNach = [];
  function planeReiter() {
    if (!reiterRaf) reiterRaf = requestAnimationFrame(function () { reiterRaf = 0; pruefeReiter(); });
    /* Sticky-Leiste und Kaufbox bewegen sich nach dem Scrollen noch (Einblenden): kurz nachprüfen */
    reiterNach.forEach(clearTimeout);
    reiterNach = [120, 300, 600, 1000].map(function (ms) { return window.setTimeout(pruefeReiter, ms); });
  }
  function versteckeReiter() {
    if (reiter) reiter.hidden = true;
    if (reiterTimer) { clearInterval(reiterTimer); reiterTimer = 0; window.removeEventListener('scroll', planeReiter); window.removeEventListener('resize', planeReiter); document.removeEventListener('transitionrun', planeReiter, true); document.removeEventListener('animationstart', planeReiter, true); }
  }
  function pruefeReiter() {
    if (!reiter) return;
    var verdeckt = andereOffen() || (dlg && dlg.open);
    reiter.classList.toggle('vg-rg-reiter--weg', !!verdeckt);
    var unten = 18;
    var sticky = document.querySelectorAll('.vgp-sticky');
    for (var i = 0; i < sticky.length; i++) {
      /* Platz der Sticky-Leiste immer freihalten, auch während sie ein- oder ausfährt */
      var r = sticky[i].getBoundingClientRect(), hS = sticky[i].offsetHeight;
      if (hS > 0 && window.getComputedStyle(sticky[i]).display !== 'none') {
        var rw0 = reiter.offsetWidth || 230;
        if (r.right > window.innerWidth - rw0 - 30) unten = Math.max(unten, hS + 12, r.top < window.innerHeight ? window.innerHeight - r.top + 12 : 0);
      }
    }
    reiter.style.bottom = unten + 'px';
    if (!verdeckt) {
      var W = window.innerWidth, H = window.innerHeight, rw = reiter.offsetWidth || 220, rechts = W < 750 ? 12 : 18;
      var rr2 = { left: W - rechts - rw, right: W - rechts, top: H - unten - 44, bottom: H - unten };
      reiter.classList.toggle('vg-rg-reiter--weg', ueberlapptSchutz(rr2) || !!blase);
    }
    if (blase) platziereBlase(unten);
  }
  function platziereBlase(unten) {
    if (!blase) return;
    var W = window.innerWidth, H = window.innerHeight, bw = blase.offsetWidth, bh = blase.offsetHeight, rand = W < 750 ? 12 : 18;
    var kopf = document.querySelector('header'), kb = kopf ? Math.max(0, kopf.getBoundingClientRect().bottom) : 0;
    var orte = [
      { x: W - rand - bw, y: H - (unten || 18) - bh },
      { x: rand, y: H - (unten || 18) - bh },
      { x: W - rand - bw, y: kb + 12 },
      { x: rand, y: kb + 12 }
    ];
    var wahl = orte[0];
    for (var i = 0; i < orte.length; i++) {
      var o = orte[i];
      if (!ueberlapptSchutz({ left: o.x, right: o.x + bw, top: o.y, bottom: o.y + bh })) { wahl = o; break; }
    }
    blase.style.left = Math.round(Math.max(rand, wahl.x)) + 'px';
    blase.style.top = Math.round(Math.max(kb + 8, wahl.y)) + 'px';
    blase.style.right = 'auto'; blase.style.bottom = 'auto';
  }

  /* ---------- Kleine Frage (Produktseite oder zweiter Auftritt) ---------- */
  var blase = null;
  function blaseKlickDaneben(e) {
    if (!blase) return;
    if (blase.contains(e.target) || (reiter && reiter.contains(e.target))) return;
    wegklick();
  }
  function blaseTaste(e) { if (blase && e.key === 'Escape') { e.preventDefault(); wegklick(); } }
  function zeigeBlase(art) {
    if (blase || (dlg && dlg.open)) return;
    if (art === 'nochmal') { st.a = 2; st.x = true; st.r = true; sichere(); }
    zeigeReiterTemporaer();
    blase = el('div', { class: 'vg-rg-blase', role: 'dialog', 'aria-modal': 'false', 'aria-labelledby': 'vg-rg-blase-t' });
    var t = art === 'nochmal' ? 'Möchtest du den kurzen Rundgang noch einmal ansehen?' : 'Willkommen im neuen VitaGreen-Shop. Möchtest du einen kurzen Rundgang?';
    blase.innerHTML = '<button type="button" class="vg-rg-blase__zu" aria-label="Schließen, später ansehen"><svg width="14" height="14" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>' +
      '<p id="vg-rg-blase-t">' + t + '</p><div class="vg-rg-knoepfe"><button type="button" class="vg-rg-btn vg-rg-btn--primaer" data-b="ja">Ja, gern</button><button type="button" class="vg-rg-btn vg-rg-btn--nein" data-b="nein">Nein, danke</button></div>';
    blase.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.getAttribute('data-b') === 'ja') { veroeffentliche('ja', { klein: true }); starte(1); }
      else if (b.getAttribute('data-b') === 'nein') nein();
      else wegklick();
    });
    document.body.appendChild(blase);
    document.addEventListener('keydown', blaseTaste);
    window.setTimeout(function () { if (blase) document.addEventListener('click', blaseKlickDaneben, true); }, 0);
    pruefeReiter();
    veroeffentliche('frage', { klein: true, art: art });
  }
  function zeigeReiterTemporaer() { zeigeReiter(); }
  function versteckeBlase() {
    document.removeEventListener('keydown', blaseTaste);
    document.removeEventListener('click', blaseKlickDaneben, true);
    var alle = document.querySelectorAll('.vg-rg-blase');
    for (var i = 0; i < alle.length; i++) alle[i].remove();
    blase = null;
    if (!st.r && reiter && !(dlg && dlg.open)) versteckeReiter();
  }

  /* ---------- Automatischer Auftritt ---------- */
  function automatisch() {
    if (st.s !== 'offen') return;
    if (st.r) mitCss(zeigeReiter);
    var schonGezeigt = !!(SS && SS.getItem(SKEY) === '1');
    if (st.x || (st.a || 0) >= 2 || schonGezeigt) return;
    ladeEinwilligungsApi();
    var start = Date.now(), timer = 0, erledigt = false;
    function plane(ms) { if (erledigt) return; if (timer) clearTimeout(timer); timer = window.setTimeout(bereit, ms); }
    function bereit() {
      timer = 0;
      if (erledigt) return;
      if (Date.now() - start > 60000) { erledigt = true; return; }
      if (bannerOffen() || andereOffen() || document.visibilityState === 'hidden') { plane(700); return; }
      if (SS && SS.getItem(SKEY) === '1') { erledigt = true; return; }
      erledigt = true;
      if (SS) { try { SS.setItem(SKEY, '1'); } catch (e) {} }
      mitCss(function () {
        if ((st.a || 0) === 0 && CFG.seite !== 'product') zeigeFrage();
        else zeigeBlase((st.a || 0) === 0 ? 'erst' : 'nochmal');
      });
    }
    document.addEventListener('visitorConsentCollected', function () { start = Date.now(); plane(1000); }, { once: true });
    plane(1500);
  }

  function los() {
    knoepfeVerbinden();
    if (!aktiv) return;
    if (/bot|crawl|spider|slurp|lighthouse/i.test(navigator.userAgent || '')) return;
    automatisch();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', los); else los();
})();
